<template>
    <!-- Обращения Service Desk, связанные с предметом (7-G1). ТОЛЬКО ЧТЕНИЕ: привязка
         делается из обращения — там понятно, что сломалось. -->
    <div class="inventory-requests">
        <div class="inventory-requests__loader" v-if="isLoading">
            <VSpinner></VSpinner>
        </div>

        <template v-else>
            <p class="inventory-requests__error" v-if="error">{{ error }}</p>

            <!-- Пустой список не говорит «обращений нет вовсе»: бэкенд отдаёт только те,
                 что пользователь может открыть. Поэтому формулировка — про видимые. -->
            <p class="inventory-requests__empty" v-else-if="!rows.length">Связанных обращений нет</p>

            <ul class="inventory-requests__list" v-else>
                <li class="inventory-requests__row" :key="row.id" v-for="row in rows">
                    <router-link class="inventory-requests__link" :to="requestLink(row)">
                        <div class="inventory-requests__header">
                            <span class="inventory-requests__number">№ {{ row.id }}</span>

                            <span class="inventory-requests__status" :style="{ '--status-color': row.statusColor }">
                                {{ row.statusTitle }}
                            </span>

                            <span class="inventory-requests__date" v-if="row.createdAt" :title="row.createdAt">
                                {{ $_toLocalDateShort(row.createdAt) }}
                            </span>
                        </div>

                        <p class="inventory-requests__service">{{ row.service }}</p>
                        <p class="inventory-requests__description" v-if="row.description">{{ row.description }}</p>
                    </router-link>
                </li>
            </ul>
        </template>
    </div>
</template>
<script>
// Components
import VSpinner from '../../../components/VProgress/VSpinner.vue';

// Other
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { getInventoryItemRequests } from '../../../../js/inventory-api';
import { errorMessage } from '../../../../js/error';
import { requestLinkRow } from '../../../../js/requestInventory';

/**
 * Вкладка «Обращения» карточки оборудования (7-G1).
 *
 * Доступ не вычисляется: бэкенд ищет предмет сквозь область просмотра, а обращения
 * отдаёт только те, что пользователь может открыть (Request::visibleTo()).
 */
@Component({
    components: {
        VSpinner,
    },
})
class VInventoryItemRequests extends Vue {
    @Prop({ type: Number, required: true })
    itemId;

    requests = [];
    isLoading = false;
    error = '';

    get rows() {
        return this.requests.map(requestLinkRow);
    }

    // Тот же вид адреса, что в письмах и чате: /request/view/:id.
    requestLink(row) {
        return { name: 'request', params: { method: 'view', id: row.id } };
    }

    async fetch() {
        this.isLoading = true;
        this.error = '';

        try {
            const response = await getInventoryItemRequests(this.itemId);

            this.requests = Array.isArray(response.data.data) ? response.data.data : [];
        } catch (requestError) {
            this.error = errorMessage(requestError);
            this.requests = [];
        } finally {
            this.isLoading = false;
        }
    }

    @Watch('itemId')
    onItemChanged() {
        this.fetch();
    }

    mounted() {
        this.fetch();
    }
}

export default VInventoryItemRequests;
</script>
<style lang="scss">
.inventory-requests {
    &__loader {
        display: flex;
        justify-content: center;
        padding: 24px 0;
    }

    &__error {
        margin: 0 0 12px;
        color: #d93025;
        font-size: 0.875rem;
    }

    &__empty {
        margin: 0;
        padding: 20px 0;
        color: #9aa0a6;
        font-size: 0.875rem;
    }

    &__list {
        margin: 0;
        padding: 0;
        list-style: none;
    }

    &__row + &__row {
        border-top: 1px solid #eef1f4;
    }

    &__link {
        display: block;
        padding: 12px 8px;
        border-radius: 8px;
        color: inherit;
        text-decoration: none;

        &:hover {
            background: #f6f8fa;
        }
    }

    &__header {
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;
        gap: 4px 12px;
    }

    &__number {
        color: #202124;
        font-size: 0.9375rem;
        font-weight: 600;
    }

    &__status {
        color: var(--status-color, #5f6368);
        font-size: 0.8125rem;
        font-weight: 500;
    }

    &__date {
        margin-left: auto;
        color: #9aa0a6;
        font-size: 0.75rem;
        white-space: nowrap;
    }

    &__service {
        margin: 4px 0 0;
        color: #202124;
        font-size: 0.875rem;
        overflow-wrap: anywhere;
    }

    &__description {
        margin: 4px 0 0;
        color: #5f6368;
        font-size: 0.8125rem;
        line-height: 1.35;
        overflow-wrap: anywhere;
    }
}
</style>
